export default __webpack_public_path__ + "static/media/clients.d48ade29.svg";